export default __webpack_public_path__ + "static/client3-8fb838a45b9e66aacaaeaff44f57915e.png";